export const useStyles = makeStyles((theme) => ({
  content: {
    padding: '40px 20px 40px 20px',
    alignSelf: 'center',
  },
  gridClear: {
    backgroundColor: theme.palette.primary.light,
    padding: '30px 20px 60px 20px',
  },
}))
export const rsv = { xs: 12, sm: 9, ms: 8, lg: 7 }
